/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { TENANTS } from "../../../constants"
import Bloc from "./Bloc"
import Field from "./Field"
import React from "react"

export default function MyAddressesBloc({ tunnelData, configuration, values }) {
  const { tenant } = tunnelData
  const { myAddresses } = configuration

  return (
    <Bloc hide={!myAddresses} name="Adresses">
      <Field
        hide={!myAddresses?.includes("shippingAddress")}
        name={"Shipping address"}
        value={values.myAddresses.shippingAddress}
      />
      <Field
        hide={!myAddresses?.includes("shippingAddressComplement")}
        name={"Shipping address 2"}
        value={values.myAddresses.shippingAddressComplement}
      />
      <Field
        hide={!myAddresses?.includes("zipShippingAddress")}
        name={"Zip"}
        value={values.myAddresses.zipShippingAddress}
      />
      <Field
        hide={!myAddresses?.includes("cityShippingAddress")}
        name={"City"}
        value={values.myAddresses.cityShippingAddress}
      />
      {tenant === TENANTS.BPLS && <div className="mt-4" />}
      <Field
        hide={!myAddresses?.includes("billingAddress")}
        name={"Billing adress"}
        value={values.myAddresses.billingAddress}
      />
      <Field
        hide={!myAddresses?.includes("billingAddressComplement")}
        name={"Billing address 2"}
        value={values.myAddresses.billingAddressComplement}
      />
      <Field
        hide={!myAddresses?.includes("zipBillingAddress")}
        name={"Zip"}
        value={values.myAddresses.zipBillingAddress}
      />
      <Field
        hide={!myAddresses?.includes("cityBillingAddress")}
        name={"City"}
        value={values.myAddresses.cityBillingAddress}
      />
    </Bloc>
  )
}
